import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Loader from './components/Loader';
import CursorEffect from './components/CursorEffect';
import NavBar from './components/NavBar';
import Hero from './sections/Hero';
import Core from './sections/Core';
import Features from './sections/Features';
import Services from './sections/Services';
import About from './sections/About';
import Founder from './sections/Founder';
import CTA from './sections/CTA';
import Footer from './sections/Footer';
import useScrollReveal from './hooks/useScrollReveal';

function HomePage() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);
    return () => clearTimeout(timer);
  }, []);

  // Initialize scroll reveal for all .reveal elements
  useScrollReveal();

  return (
    <>
      <CursorEffect />
      <Loader visible={loading} />
      <NavBar />
      <main>
        <Hero />
        <Core />
        <Features />
        <Services />
        <About />
        <Founder />
        <CTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
    </Routes>
  );
}

export default App;
